<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>人物管理 > <b>审核列表</b></BreadcrumbItem>
      </Breadcrumb>
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
		  <span class="search_span_width">
		  	<span class="search_span_width_part1">数字人ID：</span>
		  	<Input v-model="search.figure_id" placeholder="数字人ID" clearable :style="{'width':'80px'}"></Input>
		  </span>
		<span class="search_span_width">
			<span class="search_span_width_part1">训练ID：</span>
			<Input v-model="search.inner_name" placeholder="训练ID" clearable :style="{'width':'80px'}"></Input>
		</span>
        <span class="search_span_width">
                <span class="search_span_width_part1">数字人名称：</span>
                <Input v-model="search.name" placeholder="数字人名称" clearable :style="{'width':'100px'}"></Input>
              </span>
        <span class="search_span_width">
			<span class="search_span_width_part1">训练状态：</span>
			<Select v-model="search.status"  clearable style="width:120px">
			  <Option value="20">待提交审核</Option>
			  <Option value="21">审核中</Option>
			  <Option value="22">已审核，待提交训练</Option>
			  <Option value="23">审核失败</Option>
			  <Option value="1">训练中</Option>
			  <Option value="2">训练成功</Option>
			  <Option value="3">训练失败</Option>
			  <Option value="24">已上架</Option>
			</Select>
		</span>
		<span class="search_span_width">
			<span class="search_span_width_part1">提交类型：</span>
			<Select v-model="search.submit_type"  clearable style="width:100px">
				<Option value="0">所有</Option>
			  <Option value="1">代理商</Option>
			  <Option value="2">用户</Option>
			</Select>
		</span>
		 <span class="search_span_width">
			<span class="search_span_width_part1">提交人：</span>
			<Select style="width:100px"
				 v-model="search.agent_id"
				 filterable
				 clearable
				 :remote-method="userlist"
				 :loading="loading2">
				 <Option v-for="(option, index) in user_list" :value="option.id" :key="index">{{option.agent_name? option.agent_name : (option.nickname ? option.nickname :option.mobile)}}</Option>
			</Select>
		</span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getAgentFigureList(1)">搜索</Button>
    </Card>
	<Card id="tableContent" >
	  <Table :columns="tableColumns" :data="figure_list"></Table>
	  <Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getAgentFigureList"/>
	</Card>

    </Content>
    <Modal v-model="showAllmodal" :footer-hide=true title="数字人训练信息">
      <Form ref="figureAll" :model="figure" :label-width="100">
        <FormItem prop="figure_id" style="height: 0px;">
          <Input v-model="figure.figure_id" v-show="false" />
        </FormItem>
        <FormItem label="数字人名称" prop="name" class="ivu-form-item ivu-form-item-required">
          <Input v-model="figure.name" />
        </FormItem>
        <FormItem label="渠道" prop="channel" class="ivu-form-item ivu-form-item-required">
          <Select v-model="figure.channel" multiple style="width:260px" disabled>
            <Option v-for="(item,index) in channel_list" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="性别" prop="sex">
          <RadioGroup v-model="figure.sex">
            <Radio label='男' >男</Radio>
            <Radio label='女' >女</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="训练抠图" prop="sub_type">
          <RadioGroup v-model="figure.sub_type">
            <Radio label="3" disabled>绿幕抠图</Radio>
            <Radio label="4" disabled>实景</Radio>
			<Radio label="5" disabled>白幕抠图</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="客户端抠图" prop="matting">
          <Select v-model="figure.matting" disabled>
					  <Option v-for="item in mattingList" :value="item.value" :key="item.value">{{ item.label }}</Option>
				  </Select>
        </FormItem>
        <FormItem label="定制类型" prop="make_type" >
          <RadioGroup v-model="figure.make_type">
            <Radio label='1' disabled>高品质</Radio>
            <Radio label='2' disabled>标准版</Radio>
            <Radio label='3' disabled>照片数字人</Radio>
            <Radio label='4' disabled>高精4K</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="figure.remark"  />
        </FormItem>
        <FormItem label="头像" prop="cover" class="ivu-form-item ivu-form-item-required">
          <div>(300x300,分辨率720,蓝色底#cbcefa)</div>
          <img :src="figure.cover" :style="{'width':'100px'}"/>
          <Upload :action="getUploadUrl" :headers="uploadHeader" :on-success="successCover">
            <Button icon="ios-cloud-upload-outline">上传头像</Button>
          </Upload>
        </FormItem>
        <FormItem label="人像" prop="thumb" class="ivu-form-item ivu-form-item-required">
          <div>(1080*1920,透明背景，png格式)</div>
          <img :src="figure.thumb" :style="{'width':'100px'}"/>
          <Upload :action="getUploadUrl" :headers="uploadHeader" :on-success="successThumb">
            <Button icon="ios-cloud-upload-outline">上传人像</Button>
          </Upload>
        </FormItem>
        <FormItem label="静默视频" prop="main" class="ivu-form-item ivu-form-item-required">
          <div>（格式.mp4，抠图+纯绿背景#00ff00，5-6秒，1080x1920,去除声音)</div>
          <video ref="main" controls="controls" :width='150' :height="200" :src="figure.main" v-show="figure.main"></video>
          <a :href="figure.main">下载</a>
        </FormItem>
        <FormItem label="口播视频" prop="koubo" class="ivu-form-item ivu-form-item-required">
          <div>（格式.mp4，抠图+纯绿背景#00ff00，5-6秒，1080x1920,去除声音)</div>
          <video ref="koubo" controls="controls" :width='150' :height="200" :src="figure.koubo" v-show="figure.koubo"></video>
          <a :href="figure.koubo">下载</a>
        </FormItem>
        <FormItem label="原视频素材:" prop="train_video" class="ivu-form-item ivu-form-item-required">
          <div>（格式.mp4）</div>
          <video ref="train_video" controls="controls" :width='150' :height="200" :src="figure.train_video" v-show="figure.train_video"></video>
          <a :href="figure.train_video">下载</a>
        </FormItem>
        <FormItem label="训练视频：" prop="video" class="ivu-form-item ivu-form-item-required">
          <div>（格式.mp4，抠图+纯绿背景#00ff00，4-6分钟，分辨率4k或1080p)</div>
          <video ref="video" controls="controls" :width='150' :height="200" :src="figure.video" v-show="figure.video"></video>
          <a :href="figure.video">下载</a>
          <Upload :before-upload="handleUpload" action="//jsonplaceholder.typicode.com/posts/">
            <Button icon="ios-cloud-upload-outline">上传训练视频</Button>
          </Upload>
          <Progress :percent="upLoadProgress" v-show="upLoadProgress_show" />
          <div v-if="file !== null">Upload file: {{ file.name }} <Button type="text" @click="doUpload" :loading="loadingStatus">{{ loadingStatus ? '上传中...' : '点击上传' }}</Button></div>
        </FormItem>
        <FormItem label="合规文件：" prop="authorization_file" class="ivu-form-item ivu-form-item-required">
          <div>单选视频</div>
          <video ref="video" controls="controls" :width='150' :height="200" :src="figure.authorization_file" v-show="figure.authorization_file"></video>
          <a :href="figure.authorization_file">下载</a>
          <Upload :before-upload="handleUploadauth"	action="//jsonplaceholder.typicode.com/posts/">
            <Button icon="ios-cloud-upload-outline">上传合规文件</Button>
          </Upload>
          <Progress :percent="upLoadProgress_auth" v-show="upLoadProgress_show_auth" />
          <div v-if="file_auth !== null">Upload file: {{ file_auth.name }} <Button type="text" @click="doUploadauth" :loading="loadingStatus_auth">{{ loadingStatus_auth ? '上传中...' : '点击上传' }}</Button></div>
        </FormItem>
        <FormItem label="姓名" prop="real_name" class="ivu-form-item ivu-form-item-required">
          <Input v-model="figure.real_name" />
        </FormItem>
        <FormItem label="身份证号码" prop="id_card" class="ivu-form-item ivu-form-item-required">
          <Input v-model="figure.id_card" />
        </FormItem>
        <FormItem v-if="figure.submit_status ==1">
          <Button type="primary" @click="figureSubmit(2)">审核通过</Button>
          <Button type="error" @click="figureReturnSubmit()" style="margin-left: 8px">拒绝</Button>
          <Button type="primary" @click="figureSubmit(0)" style="margin-left: 8px">保存</Button>
        </FormItem>

      </Form>
    </Modal>
    <Modal v-model="showreturncharge" :footer-hide="true" title="审核意见">
      <Form ref="submit_feedbacks" :model="submit_feedbacks" :label-width="80">
        <FormItem label="审核意见" prop="name" class="ivu-form-item ivu-form-item-required">
          <Input v-model="submit_feedbacks.submit_feedback"  type="textarea" :rows="6" />
        </FormItem>
        <FormItem>
          <Button @click="closereturnModal" style="margin-left: 8px">取消</Button>&nbsp;&nbsp;&nbsp;&nbsp;
          <Button type="primary" @click="figureSubmit(3)">提交</Button>
        </FormItem>
      </Form>
    </Modal>
  </Layout>
</template>
<script>
import OSS from 'ali-oss';

export default {
  data(){
    return {
      content_data:'',
      search : {
		figure_id:'',
        name:"",
        status:0,
        inner_name:"",
		agent_id:0,
		submit_type:'0'
      },
      file:null,
      upLoadProgress:0,
      upLoadProgress_show:false,
      loadingStatus:false,
      file_auth:null,
      upLoadProgress_auth:0,
      upLoadProgress_show_auth:false,
      loadingStatus_auth:false,
      authorization_file_img:true,
      authorization_file_video:false,
      showAllmodal:false,
      showreturncharge:false,
      loading2: false,
      recordTotal:0,
      submit_feedbacks:{
        submit_feedback:"",
      },
      page:1,
      figure_list:[],
      user_list:[],
      channel_list:[],
      mattingList: [
        {
          value: '-1',
          label: '不抠图'
        },
        {
          value: '4',
          label: 'v1'
        },
        {
          value: '5',
          label: 'v2'
        }
      ],
      figure:{
        id:0,
        title:'',
        ip_type:'1',
        name:'',
        cover:'',
        thumb:'',
        main:'',
        screen:'2',
        size:0,
        sex:'女',
        make_type:'1',
        sub_type:'4',
        koubo:'',
        koubo_size:0,
        koubo_duration:0,
        material_change:0,
        agent_id:0,
        train_video:'',
        video:'',
        figure_id:0,
        train_name:'',
        webm:'',
        submit_status:0,
        train_id:0,
        authorization_file:'',
        authorization_file_type:"2",
        inner_name:"",
        channel:[],
        submit_pass_time:"",
        remark:"",
        matting:"",
        real_name:"",
        id_card:""
      },
      user_figure_data:[],
      tableColumns:[
        { title: 'ID', key: 'id', align: 'center',width:80 },
        { title: '训练ID', key: 'inner_name', align: 'center',width: 100,render:(h,params) =>{
            return h('span',{},params.row.inner_name ? 'F'+params.row.inner_name : '');
          }
		},
		{ title: '训练次数', key: 'train_number', align: 'center',width:80 },
        { title: '数字人名称', key: 'title', align: 'center' },
        { title: '提交人名称', key: 'agent_name', align: 'center',
          render:(h,params) =>{
            return params.row.agent_name ? h('Button', {
                    props: {type: 'text'},
                    style: { marginBottom: '5px'},
                    on: {
                      click: () => {
						  this.getTrainUser(params.row.id);
                        
                      }
                    }
                  }, params.row.agent_name) : '';
          }
		},
        { title: '头像', key: 'cover', align: 'center',
          render:(h,params) =>{
            return h('img',{
              attrs : {src : params.row.cover},
              style : { width : '80px', height : '80px' }
            })
          }},
        { title: '展示视频', key: 'main', align: 'center',width: 100,
          render: (h, params) => {
            let btns=[]
            if (params.row.main !== '') {
              btns.push(
                  h('Button', {
                    props: {type: 'info',size: 'small'},
                    style: { marginBottom: '5px'},
                    on: {
                      click: () => {
                        window.open(params.row.main)
                      }
                    }
                  }, '静默视频'));
            }
            if (params.row.voice_video !== '') {
              btns.push(
                  h('Button', {
                    props: {type: 'primary',size: 'small'},
                    style: {marginBottom: '5px'},
                    on:{
                      click: () => {
                        window.open(params.row.voice_video)
                      }
                    }
                  }, '口播视频'));
            }
            return h("div",btns);
          }},
        { title: '训练素材', key: 'train_video', align: 'center',width: 100,
          render: (h, params) => {
            let btns=[]
            if (params.row.train_video !== '') {
              btns.push(
                  h('Button', {
                    props: {type: 'info',size: 'small'},
                    style: {marginBottom: '5px'},
                    on: {
                      click: () => {
                        window.open(params.row.train_video)
                      }
                    }
                  }, '原始视频'));
            }
            if (params.row.video !== '') {
              btns.push(
                  h('Button', {
                    props: {type: 'success',size: 'small'},
                    style: {marginBottom: '5px'},
                    on: {
                      click: () => {
                        window.open(params.row.video)
                      }
                    }
                  }, '训练视频'));
              if (params.row.authorization_file !== '') {
                btns.push(
                    h('Button', {
                      props: {type: 'primary',size: 'small'},
                      style: {marginBottom: '5px'},
                      on: {
                        click: () => {
                          window.open(params.row.authorization_file)
                        }
                      }
                    }, '授权文件'));
              }
            }
            return h("div",btns);
          }},
        { title: '最新提交时间', key: 'train_create_time', align: 'center' },
        { title: '抠图', key: 'sub_type', align: 'center',width: 80,
          render: (h, params) => {
            var txt = '';
            if (params.row.sub_type =='3') {
              txt = '绿幕抠图';
            } else if (params.row.sub_type =='4') {
              txt = '实景';
			  if (params.row.matting == '-1') {
				  txt += '(不扣绿)'
			  } else {
				  txt += '(扣绿)';
			  }
            } else if (params.row.sub_type =='5') {
				txt = '白幕抠图';
			} else {
              txt = '有问题';
            }
            return h("div",{},txt);
          }
        },
        // { title: '训练状态', key: 'train_status_name', align: 'center',width: 100,
        //   render: (h, params) => {
        //     var txt = '';
        //     if (params.row.submit_status ==0) {
        //       txt = '待提交审核';
        //     } else if(params.row.submit_status ==1){
        //       txt = '审核中';
        //     }else if(params.row.submit_status ==2){
        //       //alert(params.row.status);
        //       if(params.row.status == '1'){
        //         txt ="已上架";
        //       }else{
        //         txt =params.row.train_status_name;
        //       }
        //     }else{
        //       txt = '审核失败';
        //     }

        //     return h("div",{},txt);
        //   }
        // },
        { title: '操作', key: 'action', align: 'center',width: 100,
          render: (h, params) => {
            let btns=[]
            btns.push(
                h('Button',{
                  props: {type: 'warning',size: 'small'},
                  style: { marginRight: '5px', marginBottom: '5px'},
                  on: {
                    click: () => {
                      this.figure.name = params.row.name;
                      this.figure.agent_id =params.row.agent_id;
                      this.figure.train_id =params.row.train_id;
                      this.figure.title = params.row.title;
                      this.figure.id = params.row.id;
                      this.figure.cover = params.row.cover;
                      this.figure.thumb = params.row.thumb;
                      this.figure.seq = params.row.seq;
                      this.figure.sex = params.row.sex;
                      this.figure.make_type = params.row.make_type.toString();
                      this.figure.main = params.row.main;
                      this.figure.size = params.row.size;
                      this.figure.ip_type = params.row.ip_type;
                      this.figure.screen = params.row.screen;
                      this.figure.sub_type = params.row.sub_type;
                      this.figure.train_video = params.row.train_video;
                      this.figure.webm = params.row.webm;
                      this.figure.video =params.row.video;
                      this.figure.submit_status =params.row.submit_status;
                      this.figure.authorization_file_type =params.row.authorization_file_type.toString();
                      this.figure.authorization_file =params.row.authorization_file;
                      this.figure.remark =params.row.remark;
                      this.figure.channel = params.row.channel;
                      if (params.row.voice_video) {
                        this.figure.koubo = params.row.voice_video;
                        this.figure.koubo_duration = params.row.koubo_duration;
                        this.figure.koubo_size = params.row.koubo_size;
                      }
                      /*                      if(this.figure.authorization_file_type =="2"){
                                              this.authorization_file_video=true;
                                              this.authorization_file_img=false;
                                              document.getElementById('authorization_file_type_content').innerText='支持mp4格式';
                                            }else{
                                              document.getElementById('authorization_file_type_content').innerText='支持jpg/jpeg,.png .pdf格式';
                                              this.authorization_file_img=true;
                                              this.authorization_file_video=false;
                                            }*/
                      this.figure.matting = params.row.matting.toString();
                      this.figure.real_name = params.row.real_name;
                      this.figure.id_card = params.row.id_card;
                      this.showAllmodal = true;
                    }
                  }

                }, '查看'),
            );
            return h("div",btns);
          }
        }
      ],
      uploadHeader:{
        "Authorization":localStorage.getItem('token')
      },
    }
  },
  mounted:function(){
    this.getAgentFigureList();
	this.getChannel();
  },
  computed:{
    getUploadUrl(){
      return process.env.VUE_APP_APIHOST+'/admin/figure/upload';
    }
  },
  methods:{
	userlist(query){
		if (this.search.submit_type == 0) {
			this.$Message.error('请先选择提交类型');
			return;
		}
	  if (query !== '' && query.length>=4) {
	  	this.loading2 = true;
	  	setTimeout(() => {
			if (this.search.submit_type ==1) {
				this.http1.get('/agent/searchList',{params:{agent_name:query}}).then(response=>{
				  let data=response.data;
				  if(data.code!==0)
				  {
					alert(data.message);
				  } else{
					this.user_list = data.data;
					this.loading2 = false;
				  }
				}).catch(()=>{
				  this.$Message.error('网络错误');
				});
			} else {
				this.http1.get('/user/getUserSelectAll',{params:{nickname:query}}).then(response=>{
				  let data=response.data;
				  if(data.code!==0)
				  {
					alert(data.message);
				  } else{
					this.user_list = data.data;
					this.loading2 = false;
				  }
				}).catch(()=>{
				  this.$Message.error('网络错误');
				});
			}
	  	}, 500);
	  }
	},
    figureSubmit(s_type){
      this.figure.submit_status =s_type;
      if(s_type ==0){
        this.$Modal.confirm({
          content: '<p>确定保存提交？</p>',
          onOk: () => {
            this.showAllmodal = false;
            this.http.post('/admin/figure/upsertAll',this.figure).then(response=>{
              let data=response.data;
              if(data.code!==0) {
                this.$Message.error(data.message);
                return false;
              } else{
                this.$Message.info(data.message);
                this.showAllmodal = false;
                this.getAgentFigureList(this.page);
                return true;
              }
            });
          },
          onCancel: () => {
            alert('退出');
          }
        });
      }else{
        this.$refs["figureAll"].validate((valid) => {
          if (valid) {
            /*          this.content_data ='<p>确定训练素材无误，确定提交？</p>';
                      if(this.figure.submit_status ==3){
                        this.content_data ='<p>确认拒绝审核？</p>';
                      }*/
            if(this.figure.submit_status ==3){
              if(this.submit_feedbacks.submit_feedback ==""){
                alert("请输入审核意见");
                return false;
              }
              let submit_feedback =this.submit_feedbacks.submit_feedback.toString().length;
              if(submit_feedback>=100){
                alert("审核意见字数不能大于100");
                return false;
              }

            }
            this.showAllmodal = false;
            this.http.post('/admin/figure/submitStatusFigure',
                {
                  id:this.figure.id,remark:this.figure.remark,submit_status:this.figure.submit_status,
                  agent_id:this.figure.agent_id,
                  train_id:this.figure.train_id,
                  submit_feedback:this.submit_feedbacks.submit_feedback
                }).then(response=>{
              let data=response.data;
              if(data.code!==0) {
                this.$Message.error(data.message);
                return false;
              } else{
                this.$Message.info(data.message);
                this.showAllmodal = false;
                this.showreturncharge =false;
                this.getAgentFigureList(this.page);
                return true;
              }
            });
          }
        })
      }

    },
    getAgentFigureList(page=this.page) {
      this.page = page;
      let p = {'page' : page}
      let params = Object.assign(this.search, p);
      this.http.get('/admin/figure/agentFigurelist',{params:params}).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.figure_list = data.data.list;
          this.recordTotal = data.data.total;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
	getTrainUser(figure_id) {
	  this.http1.get('/figure/getTrainUser',{params:{figure_id:figure_id}}).then(response=>{
	    let data=response.data;
	    if(data.code!==0){
	      alert(data.message);
	    } else{
	      this.$Modal.info({content:data.data});
	    }
	  }).catch(()=>{
	    this.$Message.error('网络错误');
	  });
	},
    getChannel() {
      this.http.get('/admin/common/getChannelList',{params:{'key':'app_channel'}}).then(response=>{
        let data=response.data;
        console.log(data);
        if(data.code!==0){
          alert(data.message);
        } else{
          this.channel_list = data.data;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    figureReturnSubmit(){
      this.showreturncharge = true;
    },
    closereturnModal(){
      this.showreturncharge = false;
    },
    successCover(response, file, fileList){
      let data=response
      if(data.code!=0) {
        this.$Message.error(data.message);
        return true;
      }
      this.figure.cover = data.data.url;
      this.$Message.success('上传成功');
    },
    successThumb(response, file, fileList){
      let data=response
      if(data.code!=0) {
        this.$Message.error(data.message);
        return true;
      }
      this.figure.thumb = data.data.url;
      this.$Message.success('上传成功');
    },
    handleUpload (file) {
      this.file = file;
      return false;
    },
    handleUploadauth(file){
      this.file_auth = file;
      return false;
    },
    doUpload() {
      this.http.get('/admin/figure/getUpoadVideoToken?bucket=ipbuilder-private').then(response=>{
        let data=response.data;
        if(data.StatusCode!=200){
          this.$Message.error(data.message);
        } else {
          const config = data;

          const ossClient = new OSS({accessKeyId: config.AccessKeyId,accessKeySecret: config.AccessKeySecret,
            stsToken: config.SecurityToken,bucket:config.bucket,region:config.RegionId,
            secure:true,endpoint:'oss-cn-zhangjiakou.aliyuncs.com'
          });
          let myDate = new Date((new Date).getTime() + 8*60*60*1000);
          let time = myDate.toJSON().split('T').join('').substr(0,12).replaceAll('-', '').toString();
          let lastIndex = this.file.name.lastIndexOf('.');
          let ext = this.file.name.substring(lastIndex+1);
          const fileName = this.figure.id+'-'+time+Math.round(Math.random()*10).toString()+'_mp4.'+ext;
          const progress = (p, _checkpoint) => {
            // Object的上传进度。
            this.upLoadProgress_show = true;
            this.upLoadProgress = parseInt(p*100);
          };

          ossClient.multipartUpload('freefishpc/figure/train/'+fileName, this.file,{progress}).then(
              result => {
                if (process.env.NODE_ENV === 'test') {
                  this.file = null;
                  var url = result.res.requestUrls[0];
                  var index = url.indexOf("?");
                  this.figure.video = url.substr(0, index);
                }else{
                  const signatureUrl = ossClient.signatureUrl('freefishpc/figure/train/'+fileName);
                  this.figure.video = signatureUrl;
                }


                console.log(`Common upload ${fileName} succeeded, result === `, result)
              }).catch(
              err => {
                console.log(`Common upload ${fileName} failed === `, err);
              });
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    doUploadauth() {
      this.http.get('/admin/figure/getUpoadVideoToken?bucket=ipbuilder-private').then(response=>{
        let data=response.data;
        if(data.StatusCode!=200){
          this.$Message.error(data.message);
        } else {
          const config = data;
          const ossClient = new OSS({accessKeyId: config.AccessKeyId,accessKeySecret: config.AccessKeySecret,
            stsToken: config.SecurityToken,bucket:config.bucket,region:config.RegionId,
            secure:true,endpoint:'oss-cn-zhangjiakou.aliyuncs.com'
          });
          let myDate = new Date((new Date).getTime() + 8*60*60*1000);
          let time = myDate.toJSON().split('T').join('').substr(0,12).replaceAll('-', '').toString();
          let lastIndex = this.file_auth.name.lastIndexOf('.');
          let ext = this.file_auth.name.substring(lastIndex+1);
          const fileName = this.figure.id+'-'+time+Math.round(Math.random()*10).toString()+'_authorize.'+ext;

          const progress = (p, _checkpoint) => {
            this.upLoadProgress_show_auth = true;
            this.upLoadProgress_auth = parseInt(p*100);
          };

          ossClient.multipartUpload('freefishpc/figure/train/'+fileName, this.file_auth,{progress}).then(
              result => {
                if (process.env.NODE_ENV === 'test') {
                  this.file_auth = null;
                  var url = result.res.requestUrls[0];
                  var index = url.indexOf("?");
                  this.figure.authorization_file = url.substr(0, index);
                }else{
                  const signatureUrl = ossClient.signatureUrl('freefishpc/figure/train/'+fileName);
                  this.figure.authorization_file = signatureUrl;
                }

                console.log(`Common upload ${fileName} succeeded, result === `, result)
              }).catch(
              err => {
                console.log(`Common upload ${fileName} failed === `, err);
              });
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
  }

}
</script>
<style>
.oss_file {
  height: 150px;
  width: 150px;
  background: rgba(208, 211, 126, 0.397);
}
img {
  width: 100%;
  display: inline-block;
  /*  float: right;*/
}
.oss_file input {
  right: 0;
  top: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  cursor: pointer;
  width: 100%;
  height: 100%;
}
</style>